"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fabric_1 = require("fabric");
var Canvas = /** @class */ (function () {
    function Canvas(_a) {
        var id = _a.id, config = _a.config, editor = _a.editor;
        var _this = this;
        this.options = {
            width: 0,
            height: 0,
        };
        this.initialize = function () {
            var canvas = new fabric_1.fabric.Canvas(_this.canvasId, {
                backgroundColor: _this.config.background,
                preserveObjectStacking: true,
                fireRightClick: true,
                height: _this.config.size.height,
                width: _this.config.size.width,
            });
            _this.canvas = canvas;
            _this.canvas.disableEvents = function () {
                if (this.__fire === undefined) {
                    this.__fire = this.fire;
                    // @ts-ignore
                    this.fire = function () { };
                }
            };
            _this.canvas.enableEvents = function () {
                if (this.__fire !== undefined) {
                    this.fire = this.__fire;
                    this.__fire = undefined;
                }
            };
        };
        this.destroy = function () {
            // this.canvas.dispose()
            // this.dettachResizeObserver()
        };
        this.config = config;
        this.editor = editor;
        this.canvasId = id;
        this.initialize();
    }
    Canvas.prototype.resize = function (_a) {
        var width = _a.width, height = _a.height;
        this.canvas.setWidth(width).setHeight(height);
        this.canvas.renderAll();
        var diffWidth = width / 2 - this.options.width / 2;
        var diffHeight = height / 2 - this.options.height / 2;
        this.options.width = width;
        this.options.height = height;
        var deltaPoint = new fabric_1.fabric.Point(diffWidth, diffHeight);
        this.canvas.relativePan(deltaPoint);
    };
    Canvas.prototype.getBoundingClientRect = function () {
        var canvasEl = document.getElementById("canvas");
        var position = {
            left: canvasEl === null || canvasEl === void 0 ? void 0 : canvasEl.getBoundingClientRect().left,
            top: canvasEl === null || canvasEl === void 0 ? void 0 : canvasEl.getBoundingClientRect().top,
        };
        return position;
    };
    Canvas.prototype.requestRenderAll = function () {
        this.canvas.requestRenderAll();
    };
    Object.defineProperty(Canvas.prototype, "backgroundColor", {
        get: function () {
            return this.canvas.backgroundColor;
        },
        enumerable: false,
        configurable: true
    });
    Canvas.prototype.setBackgroundColor = function (color) {
        var _this = this;
        this.canvas.setBackgroundColor(color, function () {
            _this.canvas.requestRenderAll();
            _this.editor.emit("canvas:updated");
        });
    };
    return Canvas;
}());
exports.default = Canvas;
//# sourceMappingURL=canvas.js.map